import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import 'MagnificPopup';
import 'slick';
import { memberPortal } from "../member-portal";

export class memberClaimMissingMiles {
	private memberBase:any = new memberPortal();
	private claimMABForm:any     = $('#claim-airlines-mab-form');
	private claimPartnerForm:any = $('#claim-airlines-partners-form');
	private claimOtherForm:any   = $('#claim-airlines-others-form');

	/**
	 * initialize all form inputs with focus and filled effects
	 * find all instances of text inputs in all 3 forms on page
	 * combine them into an array and apply effect to all fields
	 * @return {any} [description]
	 */
	initTextInputs(): any {
		let _self = this;
		let claimMABInputElArr:any     = $.makeArray(_self.claimMABForm.find('input[type="text"]'));
		let claimPartnerInputElArr:any = $.makeArray(_self.claimPartnerForm.find('input[type="text"]'));
		let claimOtherInputElArr:any   = $.makeArray(_self.claimOtherForm.find('input[type="text"]'));
		
		let inputElArr:any = claimMABInputElArr.concat(claimPartnerInputElArr, claimOtherInputElArr);

		_self.memberBase.initFormTextInputs(inputElArr);
	}

	initSelectizeInputs(): any {
		let _self = this;

		// MAB
		let claimMABInputSelectArr = $('#claim-miles--flight-origin,#claim-miles--flight-destination');
		let getTitleOptions = $.Deferred();

		$.get('/bin/services/new/getAirportCountryJSON')
		.done((data:any) => {
			let listItems = "<option value=''> </option>";
			for (let i = 0; i < data.airportsList.length; i++) {
				listItems += "<optgroup label='" + data.airportsList[i].countryName + "'>";
				for (let j = 0; j < data.airportsList[i].airports.length; j++) {
					listItems += "<option value='" + data.airportsList[i].airports[j].airportCode + "'>" + data.airportsList[i].airports[j].airportName + ", " + data.airportsList[i].airports[j].airportCode + "</option>";
				}
				listItems += '</optgroup>';
			}
			getTitleOptions.resolve(listItems);
		})
		.fail((error:any) => {
			getTitleOptions.reject(error);
		});

		

		$.when(getTitleOptions).done(function(titleOptions:any) {
			claimMABInputSelectArr.html(titleOptions);
			_self.memberBase.initSelectizeInputs(claimMABInputSelectArr);
		});

    // Airline Partner
    let selectInputAirlinePartner = $("#claim-partners--airline-partner");
    let getAirlineOptions = $.Deferred();

    $.get('/content/dam/mas/json/airlinesPartner.json')
    .done((data:any) => {
    	let listItems = "<option value=''> </option>";
    	for (let i = 0; i < data.airlinesPartner.length; i++) {
    		listItems += "<option data-partner='" +  data.airlinesPartner[i].label + "' value='" + data.airlinesPartner[i].value + "'>" + data.airlinesPartner[i].label + "</option>";
    	}
    	getAirlineOptions.resolve(listItems);
    })
    .fail((error:any) => {
    	getAirlineOptions.reject(error);
    });

	$(selectInputAirlinePartner).change(function(event: any) {
		var selectedVal = $(event.currentTarget).find(':selected').html();
		console.log(selectedVal);
		$('#claimAirlinesPartnersChanged').attr('data-claim-partners--airline-partner-changed', selectedVal);
	});

    $.when(getAirlineOptions).done(function(airLineOptions:any) {
    	selectInputAirlinePartner.html(airLineOptions);
    	_self.memberBase.initSelectizeInputs(selectInputAirlinePartner);
    });

    // Airline Partner Orgin and Destination
	  let selectInputAirlinePartnerOND = $("#claim-partners--flight-origin,#claim-partners--flight-destination");
	  let getAirlineOptionsOND = $.Deferred();

	  $.get('/content/dam/mas/json/activePorts.json').done((data:any) => {
		  let listItems = "<option value=''> </option>";
		  for (let i = 0; i < data.activePorts.length; i++) {
			  listItems += "<option value='" + data.activePorts[i].value + "'>" + data.activePorts[i].label + "</option>";
		  }
		  getAirlineOptionsOND.resolve(listItems);
	  }).fail((error:any) => {
		  getAirlineOptionsOND.reject(error);
	  });

	  $.when(getAirlineOptionsOND).done(function(airLineOptions:any) {
		  selectInputAirlinePartnerOND.html(airLineOptions);
		  _self.memberBase.initSelectizeInputs(selectInputAirlinePartnerOND);
	  });

		// Non Airline Company List
		let selectInputOtherAirlinePartner = $("#claim-others--airline-partner");
		let getOtherAirlineOptions = $.Deferred();

		$.get('/content/dam/mas/json/nonAirlinesPartners.json').done((data:any) => {
		    let listItems = "<option value=''> </option>";
		    for (let i = 0; i < data.nonAirlinesPartner.length; i++) {
		        listItems += "<option value='" + data.nonAirlinesPartner[i].label + "'>" + data.nonAirlinesPartner[i].label + "</option>";
		    }
		    getOtherAirlineOptions.resolve(listItems);
		}).fail((error:any) => {
		    getOtherAirlineOptions.reject(error);
		});

		$(selectInputOtherAirlinePartner).change(function(event: any) {
				var selectedVal = $(event.currentTarget).find(':selected').html();
				console.log(selectedVal);
				$('#claimAirlinesOtherPartnerChanged').attr('data-claim-others--partner-changed', selectedVal);
		});

		$.when(getOtherAirlineOptions).done(function(airLineOptions:any) {
		    selectInputOtherAirlinePartner.html(airLineOptions);
		    _self.memberBase.initSelectizeInputs(selectInputOtherAirlinePartner);
		});

		// Filling Location Service
		let selectInputOtherLocaltionService = $("#claim-others--location-service");
		let getOtherAirlineLocationServvice = $.Deferred();

		$.get('/content/dam/mas/json/countrycode.json').done((data:any) => {
		    let listItems = "<option value=''> </option>";
		    for (let i = 0; i < data.Countries.length; i++) {
		        listItems += "<option value='" + data.Countries[i].Name + "'>" + data.Countries[i].Name + "</option>";
		    }
		    getOtherAirlineLocationServvice.resolve(listItems);
		}).fail((error:any) => {
		    getOtherAirlineLocationServvice.reject(error);
		});

		$(selectInputOtherLocaltionService).change(function(event: any) {
				var selectedValLoc = $(event.currentTarget).find(':selected').html();
				console.log(selectedValLoc);
				$('#claimAirlinesOthersLocationChanged').attr('data-claim-others-location--changed', selectedValLoc);
		});

		$.when(getOtherAirlineLocationServvice).done(function(airLineOptions:any) {
		    selectInputOtherLocaltionService.html(airLineOptions);
		    _self.memberBase.initSelectizeInputs(selectInputOtherLocaltionService);
		});

		// ProofOfActivity
		let selectInputProofOfActivity = $("#claim-others--proof-activity");
		let getOtherAirlineProofOfActivity = $.Deferred();

		$.get('/content/dam/mas/json/proofOfActivity.json').done((data:any) => {
		    let listItems = "<option value=''> </option>";
		    for (let i = 0; i < data.proofOfActivity.length; i++) {
		        listItems += "<option value='" + data.proofOfActivity[i].label + "'>" + data.proofOfActivity[i].value + "</option>";
		    }
		    getOtherAirlineProofOfActivity.resolve(listItems);
		}).fail((error:any) => {
		    getOtherAirlineProofOfActivity.reject(error);
		});

		$.when(getOtherAirlineProofOfActivity).done(function(airLineOptions:any) {
		    selectInputProofOfActivity.html(airLineOptions);
		    _self.memberBase.initSelectizeInputs(selectInputProofOfActivity);
		});
	}

	initDatepickerInputs(): any {
		let _self = this;
		let inputDateArr = $('.datepicker');
		let minDate = '-6m';
		let maxDate = new Date((new Date()).toString());

		_self.memberBase.initDatepickerInputs(inputDateArr, minDate, maxDate);
	}

	initFileInputs(): any {
		let _self = this;
		let formContainer:any = $('.miles-claim-missing.well');

		// $(document).ready(function(){
		// 	let fileInputsArr:any = formContainer.find('.bootstrap-filestyle input');

		// 	fileInputsArr.each((i:number, el:any) => {
		// 	});

		// 	// watch for changes, if input value is not empty
		// 	// hide label text
		// });
	}

	validateForm(): any {
		let _self = this;

		// init custom length validation
		_self.memberBase.customValidationExactLength();

		_self.memberBase.validateForm(_self.claimMABForm, function(validation: any) {
			// all your custom validation here
			let flightClass = _self.claimMABForm.find('#claim-miles--cabin-class');
			flightClass.attr({
				'data-parsley-pattern': '^[a-zA-Z]+$',
				'data-parsley-maxlength': '1',
				'maxlength': '1',
				'style': 'text-transform: uppercase'
			});

			let flightNumber = _self.claimMABForm.find('#claim-miles--flight-number');
			flightNumber.attr({
				'data-parsley-maxlength': '4',
				'data-parsley-exact-length': '4',
				'maxlength': '4',
				'data-parsley-type': 'number'
			});

			let ticketNumber = _self.claimMABForm.find('#claim-miles--ticket-number');
			ticketNumber.attr({
				'data-parsley-maxlength': '13',
				'data-parsley-exact-length': '13',
				'data-parsley-type': 'number',
				'maxlength': '13'
			});

			$('#claim-miles--flight-number').on('blur', function() {
			  let $flightNum:any = '' + $(this).val();
			  let $prefixZero:any = "0000"
			  let $flightNumWithPrefix:any = $prefixZero.substring(0, $prefixZero.length - $flightNum.length) + $flightNum;
			  $(this).val($flightNumWithPrefix);
			});

		}, function(validation:any, formData:any, htmlFormData:any) {
			// on success function

			// convert flight class to uppercase
			// regenerate htmlFormData after updating case
			let flightClass = formData.find(getCabinClass);
			flightClass.value = flightClass.value.toUpperCase();
			htmlFormData = new FormData(validation.$element[0]);

			// display success message and hide form upon submission
			let successMsg = _self.claimMABForm.parents().eq(1).find('#claim-miles--success');

			_self.claimMABForm.fadeOut(400);
			setTimeout(function(){
				successMsg.fadeIn();
			}, 500);

			function getCabinClass(element:any) {
				return element.name == 'cabin-class-ownairline';
			}
		});

		_self.memberBase.validateForm(_self.claimPartnerForm, function(validation: any) {
			// all your custom validation here
			let flightClass = _self.claimPartnerForm.find('#claim-partners--cabin-class');
			flightClass.attr({
				'data-parsley-pattern': '^[a-zA-Z]+$',
				'data-parsley-maxlength': '1',
				'maxlength': '1',
				'style': 'text-transform: uppercase'
			});

			let $claimPartnersFlightNo: any = $('#claim-partners--flight-number');
			$($claimPartnersFlightNo).bind('input', function(){
				$(this).val(function(_:any, v:any){
					return v.replace(/\s+/g, '');
				});
			});

			let flightNumber = _self.claimPartnerForm.find('#claim-partners--flight-number');
			flightNumber.attr({
				'data-parsley-maxlength': '4',
				'data-parsley-exact-length': '4',
				'maxlength': '4',
				'data-parsley-type': 'number'
			});

			let ticketNumber = _self.claimPartnerForm.find('#claim-partners--ticket-number');
			ticketNumber.attr({
				'data-parsley-maxlength': '13',
				'data-parsley-exact-length': '13',
				'data-parsley-type': 'number',
				'maxlength': '13'
			});
			
			$("#claim-partners--airline-partner").change(function(){
				if ($("#claim-partners--airline-partner").val() == "FY" ){
					ticketNumber.removeAttr('required');
					$('.claim-partners--ticket-number label').removeClass('required');
				}
			});

			$('#claim-partners--flight-number').on('blur', function() {
			  let $claimPartnersFlighNum:any = $('#claim-partners--flight-number');
			  let $flightNum:any = '' + $(this).val();
			  let $prefixZero:any = "0000"
			  let $flightNumWithPrefix:any = $prefixZero.substring(0, $prefixZero.length - $flightNum.length) + $flightNum;
			  $(this).addClass('input-focused');
			  $(this).val($flightNumWithPrefix);
			  $claimPartnersFlighNum.parent().addClass('input-focused');
			  $claimPartnersFlighNum.parent().find('label').addClass('input-filled');
			});

			$('#claim-partners--airline-partner').change(function(e:any) {
				let $fromLocationGetVal:any = $(this)[0].selectize.getValue();
				let $claimPartnersFlighNum:any = $('#claim-partners--flight-number');
				$claimPartnersFlighNum.parent().find('.text-bold').html($fromLocationGetVal);
				$claimPartnersFlighNum.addClass('input-focused');
				$claimPartnersFlighNum.parent().addClass('input-focused');
				$claimPartnersFlighNum.parent().find('label').addClass('input-filled');
				$claimPartnersFlighNum.focus();
			});

		}, function(validation:any, formData:any, htmlFormData:any) {
			// on success function

			// convert flight class to uppercase
			// regenerate htmlFormData after updating case
			let flightClass = formData.find(getCabinClass);
			flightClass.value = flightClass.value.toUpperCase();
			htmlFormData = new FormData(validation.$element[0]);

			// display success message and hide form upon submission
			let successMsg = _self.claimPartnerForm.parents().eq(1).find('#claim-partners--success');

			_self.claimPartnerForm.fadeOut(400);
			setTimeout(function(){
				successMsg.fadeIn();
			}, 500);

			function getCabinClass(element:any) {
				return element.name == 'cabin-class-partner';
			}
		});

		_self.memberBase.validateForm(_self.claimOtherForm, function(validation: any) {
			// all your custom validation here
		}, function(validation:any, formData:any, htmlFormData:any) {
			// on success function

			// display success message and hide form upon submission
			let successMsg = _self.claimOtherForm.parents().eq(1).find('#claim-others--success');

			_self.claimOtherForm.fadeOut(400);
			setTimeout(function(){
				successMsg.fadeIn();
			}, 500);

			function getCabinClass(element:any) {
				return element.name == 'cabin-class';
			}
		});

		$('#claim-partners--upload-ticket').change(function (e: any) {
            let acceptedFileFormat = ["jpg", "png", "pdf", "docx", "doc"];
            let fileObj = e.currentTarget.files[0];
			let name = fileObj.name;
			var period = name.lastIndexOf(".");
            let filesExtenstion = name.substr(period+1, name.length);
            let sizeInMB = returnFileSize(fileObj.size);
            if(acceptedFileFormat.indexOf(filesExtenstion.toLowerCase()) === -1) {
                // disbaled the submit button
                $('#claim-partners-submit').attr("disabled", true);
                $('.file-extenstion-error-partner').removeClass('hideclass');
                $('.file-extenstion-error-partner').addClass('showclass');
                $('.max-file-error-partner').removeClass('showclass');
                $('.max-file-error-partner').addClass('hideclass');
                e.currentTarget.files = null;
            }else if(parseInt(sizeInMB) > 5) {
                $('#claim-partners-submit').attr("disabled", true);
                $('.max-file-error-partner').removeClass('hideclass');
                $('.max-file-error-partner').addClass('showclass');
                $('.file-extenstion-error-partner').removeClass('showclass');
                $('.file-extenstion-error-partner').addClass('hideclass');
            } else {
                // good with file validation
                if($('.file-extenstion-error').hasClass('hideclass') &&  $('.max-file-error').hasClass('hideclass')) {
					$('#claim-partners-submit').attr("disabled", false);
				}
                $('.file-extenstion-error-partner').removeClass('showclass');
                $('.file-extenstion-error-partner').addClass('hideclass');
                $('.max-file-error-partner').removeClass('showclass');
                $('.max-file-error-partner').addClass('hideclass');
            }
        });
		$('#claim-partners--upload-boarding-pass').change(function (e: any) {
            let acceptedFileFormat = ["jpg", "png", "pdf", "docx", "doc"];
            let fileObj = e.currentTarget.files[0];
			let name = fileObj.name;
			var period = name.lastIndexOf(".");
            let filesExtenstion = name.substr(period+1, name.length);
            let sizeInMB = returnFileSize(fileObj.size);
            if(acceptedFileFormat.indexOf(filesExtenstion.toLowerCase()) === -1) {
                // disbaled the submit button
                $('#claim-partners-submit').attr("disabled", true);
                $('.file-extenstion-error').removeClass('hideclass');
                $('.file-extenstion-error').addClass('showclass');
                $('.max-file-error').removeClass('showclass');
                $('.max-file-error').addClass('hideclass');
                e.currentTarget.files = null;
            }else if(parseInt(sizeInMB) > 5) {
                $('#claim-partners-submit').attr("disabled", true);
                $('.max-file-error').removeClass('hideclass');
                $('.max-file-error').addClass('showclass');
                $('.file-extenstion-error').removeClass('showclass');
                $('.file-extenstion-error').addClass('hideclass');
            } else {
                // good with file validation
				if($('.file-extenstion-error-partner').hasClass('hideclass') &&  $('.max-file-error-partner').hasClass('hideclass')) {
					$('#claim-partners-submit').attr("disabled", false);
				}
                $('.file-extenstion-error').removeClass('showclass');
                $('.file-extenstion-error').addClass('hideclass');
                $('.max-file-error').removeClass('showclass');
                $('.max-file-error').addClass('hideclass');
            }
        });
		$('#claim-others--upload-attachment').change(function (e: any) {
            let acceptedFileFormat = ["jpg", "png", "pdf", "docx", "doc"];
            let fileObj = e.currentTarget.files[0];
			let name = fileObj.name;
			var period = name.lastIndexOf(".");
            let filesExtenstion = name.substr(period+1, name.length);
            let sizeInMB = returnFileSize(fileObj.size);
            if(acceptedFileFormat.indexOf(filesExtenstion.toLowerCase()) === -1) {
                // disbaled the submit button
                $('#claim-others-submit').attr("disabled", true);
                $('.file-extenstion-error').removeClass('hideclass');
                $('.file-extenstion-error').addClass('showclass');
                $('.max-file-error').removeClass('showclass');
                $('.max-file-error').addClass('hideclass');
                e.currentTarget.files = null;
            }else if(parseInt(sizeInMB) > 5) {
                $('#claim-others-submit').attr("disabled", true);
                $('.max-file-error').removeClass('hideclass');
                $('.max-file-error').addClass('showclass');
                $('.file-extenstion-error').removeClass('showclass');
                $('.file-extenstion-error').addClass('hideclass');
            } else {
                // good with file validation
                $('#claim-others-submit').attr("disabled", false);
                $('.file-extenstion-error').removeClass('showclass');
                $('.file-extenstion-error').addClass('hideclass');
                $('.max-file-error').removeClass('showclass');
                $('.max-file-error').addClass('hideclass');
            }
        });
        function returnFileSize(number: any) {
            return (number/1048576).toFixed(1);
        }
	}

	initClaimSampleDialogs(): any {
		let _self = this;
		let sampleMABFlightClass     = _self.claimMABForm.find('#claim-MAB-sample-popup');
		let samplePartnerFlightClassNo = _self.claimPartnerForm.find('.claim-flight-partner-sample-links');
		let carouselInit:boolean = false;
		let samplePartnerCarouselObj:any;
		let samplePartnerCarousel = _self.claimPartnerForm.find('#claim-partner-sample-dialog .carousel');

		sampleMABFlightClass.magnificPopup({
			type:'inline',
			midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
		});

		samplePartnerFlightClassNo.magnificPopup({
			type:'inline',
			midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
			callbacks: {
			    open: function() {
			    	if (!carouselInit) {
			    		samplePartnerCarouselObj = samplePartnerCarousel.slick({
							infinite: true,
							speed: 400,
							slidesToShow: 1,
							slidesToScroll: 1,
							arrows : true,
							dots: true,
							adaptiveHeight: true,
							cssEase: 'linear',
							fade: true
						});

						carouselInit = true;
			    	}
				  // Will fire when this exact popup is opened
				  // this - is Magnific Popup object
				},
				close: function() {
				  // Will fire when popup is closed
				}
			}
		});
	}
}

let scope:Element = document.querySelector('#claim-airlines-mab-form');
if (scope) {
	try {
	let memberclaimmissingmiles = new memberClaimMissingMiles();
	memberclaimmissingmiles.initTextInputs();
	memberclaimmissingmiles.initSelectizeInputs();
	memberclaimmissingmiles.initDatepickerInputs();
	memberclaimmissingmiles.initFileInputs();
	memberclaimmissingmiles.initClaimSampleDialogs();
	memberclaimmissingmiles.validateForm();
	} catch(e) {console.error(e);}
}
